<template>
  <div class="dx-card-slider-tips">
    <div class="dx-card-slider-tips__slider" ref="slider"></div>
    <div class="dx-card-slider-tips__numbers">
      <div class="row no-gutters">
        <div class="col" v-for="number in numbers" :key="number">
          <span
            :class="numberClasses(number)"
            @click="setTip(number)"
            >
            {{ number }}
          </span>
        </div>
      </div>
    </div>
    <div class="dx-card-slider-tips__tip">
      {{ tip }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'dx-card-slider-tips',
  props: {
    tips: Array,
    disableds: Array
  },
  data () {
    return {
      currentTip: 1
    }
  },
  computed: {
    numbers () {
      let output = []
      for (let i in this.tips) {
        output.push(Number(i) + 1)
      }
      return output
    },
    tip () {
      return this.tips[this.currentTip - 1]
    }
  },
  methods: {
    onMove (event) {
      let x = parseInt(this.touchX(event))
      let count = this.tips.length
      let squareWidth = this.$refs.slider.clientWidth / count
      for (let i = 1; i <= count; i++) {
        let currentSquare = i * squareWidth
        if (x >= (currentSquare - squareWidth) && x <= currentSquare) {
          this.setTip(i)
        }
      }
    },
    touchX (event) {
      return event.touches[0].clientX
    },
    touchY (event) {
      return event.touches[0].clientY
    },
    setTip (number) {
      this.currentTip = number
      this.onChange()
    },
    numberClasses (number) {
      return {
        'dx-card-slider-tips__number': true,
        'dx-card-slider-tips__number--active': number === this.currentTip,
        'dx-card-slider-tips__number--disabled': this.disableds.indexOf(number) > -1
      }
    },
    onChange () {
      this.$emit('change', this.currentTip)
    }
  },
  mounted () {
    this.$refs.slider.addEventListener('touchmove', this.onMove.bind(this))
    this.$refs.slider.addEventListener('touchstart', this.onMove.bind(this))
  },
  beforeDestroy () {
    this.$refs.slider.removeEventListener('touchmove', this.onMove.bind(this))
    this.$refs.slider.removeEventListener('touchstart', this.onMove.bind(this))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxCardSliderTips.vue